<div class="wrapper">
  <div class="my-header">
    <customize-button
      class="back-home"
      type="text-normal"
      size="small"
      [routerLink]="'/'"
      [icon]="'icon-arrow-left-simple'"
    >
      <span class="text">{{ 'home' | translate }}</span>
    </customize-button>
    <div class="account">{{ userInfo.userName }}</div>
    <div class="avatar">
      <img *ngIf="userInfo.avater" [src]="userInfo.avater" />
    </div>
    <div class="balance">
      <span>{{ 'main_account' | translate }}</span>
      <span class="gap">|</span>
      <app-currency-wallet [onlyBalance]="true"></app-currency-wallet>
    </div>
  </div>
  <div class="member-menu">
    <ng-container *ngFor="let item of memberLayoutMenu; let index = index">
      <div class="item" [class]="item.page" (click)="selectMenu(item, index)" *ngIf="!item.center">
        <div class="icon" [class]="item.page">
          <i class="icon-{{ item.icon }}"></i>
        </div>
        <div class="text">{{ item.title | translate }}</div>
      </div>
    </ng-container>
  </div>
  <div class="member-menu setting-group">
    <ng-container *ngFor="let item of memberLayoutMenu2; let index = index">
      <div class="item" [class]="item.page" (click)="selectMenu(item, index)" *ngIf="!item.center">
        <div class="icon" [class]="item.page">
          <i class="icon-{{ item.icon }}"></i>
        </div>
        <div class="text">{{ item.title | translate }}</div>
      </div>
    </ng-container>
  </div>
</div>
